import { render, staticRenderFns } from "./reset-password.vue?vue&type=template&id=6378dfe4&"
import script from "./login.js?vue&type=script&lang=js&"
export * from "./login.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports